import store from '@/store/index'
import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// const ifNotAuthenticated = async (to, from, next) => {
//   if (!store.getters['Auth/isAuthenticated']) {
//     next()
//     return
//   }
//   next('/booking/vehicles')
// }

// const ifNotCorporation = async (to, from, next) => {
//   if (!store.getters['Auth/hasCorporation']) {
//     next()
//     return
//   }
//   next('/')
// }

const bookingChildren = [
  {
    path: 'vehicles',
    name: 'vehicles',
    component: () => import('@/components/booking/Vehicles.vue'),
  },
  {
    path: 'offers',
    name: 'offers',
    component: () => import('@/components/booking/Offers.vue'),
  },
  {
    path: 'date',
    name: 'date',
    component: () => import('@/components/booking/date/Date.vue'),
  },
  {
    path: 'summary',
    name: 'summary',
    component: () => import('@/components/booking/Summary.vue'),
  },
  {
    path: 'payment',
    name: 'payment',
    component: () => import('@/components/booking/payment/Payment.vue'),
    props: { cartItemType: 'booking' },
  },
  {
    path: 'finish',
    name: 'finish',
    component: () => import('@/components/booking/payment/Check3DSResult.vue')
  }
]

const topUpWalletChildren = [
  {
    path: 'wallet-offers',
    name: 'wallet-offers',
    component: () => import('@/components/userWallet/Offers.vue'),
    props: true
  },
  {
    path: 'wallet-payment',
    name: 'wallet-payment',
    component: () => import('@/components/booking/payment/Payment.vue'),
    props: { cartItemType: 'creditsPack' },
  },
]

const homeChildren = [
  {
    path: 'account',
    name: 'UserAccount',
    component: () => import('@/views/UserAccount.vue'),
  },
  {
    path: 'booking',
    name: 'booking',
    component: () => import('@/views/Booking.vue'),
    meta: { requiresBookingAllowed: true },
    children: bookingChildren
  },
  {
    path: 'wallet',
    name: 'wallet',
    component: () => import('@/views/TopUpWallet.vue'),
    meta: { requiresTopUpWalletAllowed: true },
    children: topUpWalletChildren
  }
]

const routes = [
  //   {
  //   path: '/',
  //   name: 'Start',
  //   component: () => import('@/views/Start.vue'),
  //   beforeEnter: ifNotAuthenticated
  // },
  // {
  //   path: '/old/login',
  //   name: 'Login',
  //   component: () => import('@/views/Login.vue'),
  //   meta: {
  //     requiresAuth: false
  //   },
  //   beforeEnter: ifNotAuthenticated
  // },
  // {
  //   path: '/corporation',
  //   name: 'Corporation',
  //   component: () => import('@/views/Corporation.vue'),
  //   meta: {requiresAuth: true, requiresNotFrauder:true},
  //   beforeEnter: ifNotCorporation
  // },
  {
    path: '/blocked',
    name: 'Blocked',
    component: () => import('@/views/Blocked.vue')
  },
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    meta: { requiresAuth: true, requiresCorporation: true, requiresNotFrauder: true },
    children: homeChildren
  },
  {
    path: '/:catchAll(.*)',
    name: 'NotFound',
    redirect: to => {
      const currentUrl = location.href
      // Fix TWIPWEB-221: Try to redirect url with no trailing slash to let django catch it
      if (currentUrl.charAt(currentUrl.length - 1) !== '/') {
        window.location.replace(currentUrl + '/')
      }
      // otherwise redirect to the home page
      return '/'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '',
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach(async (to, from, next) => {
  if (!store.getters['Auth/isAuthenticated']) {
    await store.dispatch('Auth/tryAutoLogin')
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters['Auth/isAuthenticated']) {
      // user not logged in should be redirected to the django home either to signup or login
      window.location.href = '/'
      return
    }
  }

  if (to.matched.some(record => record.meta.requiresNotFrauder && store.getters['Auth/isFrauder'])) {
    next('/blocked')
    return
  }

  if (to.matched.some(record => record.meta.requiresCorporation)) {
    if (!store.getters['Auth/hasCorporation'] && store.getters['Auth/isAuthenticated']) {
      next('/corporation')
      return
    }
  }
  // not use right now, be the fleet account will need this feature later.
  if (to.matched.some(record => record.meta.requiresBookingAllowed) && !store.getters['Auth/isBookingAllowed']) {
    next('/account')
    return
  }
  if (to.matched.some(record => record.meta.requiresTopUpWalletAllowed) && !store.getters['Auth/isTopUpWalletAllowed']) {
    next('/account')
    return
  }

  next()
})

router.afterEach((to, from) => {
  // call tealium page view when we change pages in vuejs
  // Note: when coming to a VueJs url directly, we load the Tealium script in the html template from Django.
  // therefore, we have already sent a page view. To avoid double hits, we only send a page view to Tealium
  // when the path is not "/" (default value use by VueJs router)
  if (from.path !== '/') {
    window.tealiumSendPageView(to)
  }

})

export default router
